import React from 'react';
import moment from "moment";
import * as utils from "../../../utils/utils";

export default class Date extends React.Component {
    render() {
        return <span>{utils.notNullNorUndefined(this.props.row.blDate) ? moment.unix(this.props.row.blDate).format('DD/MM/Y') : ''}</span>;
    }
}


// WEBPACK FOOTER //
// ./src/components/cargo/tableComponents/Date.js